import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import MuiRadioGroup from '@mui/material/RadioGroup';
import { FormControl, Radio, Typography, FormLabel, } from '@mui/material';
import SelectionItem from '../SelectionItem';
import useInputLabelDisplay from '../../../hooks/useInputLabelDisplay';
import radioGroupStyles from './radioGroup.styles';
const RadioGroup = ({ id, options, className, classes, label, ...props }) => {
    const styles = radioGroupStyles();
    const { getLabel } = useInputLabelDisplay();
    const displayedLabel = getLabel(label);
    if (!options) {
        return null;
    }
    return (_jsxs(FormControl, { className: clsx([className, styles.root, classes?.root]), "data-test": `radio_group:${id}`, children: [_jsx(FormLabel, { className: clsx([styles.label, classes?.label]), "data-test": `${id}:radioGroup:label`, children: _jsx(Typography, { variant: "subtitle1", children: displayedLabel }, void 0) }, void 0), _jsx(MuiRadioGroup, { id: id, name: id, classes: {
                    root: clsx([styles.radioGroup, classes?.radioGroup]),
                    row: clsx([styles.row, classes?.row]),
                }, ...props, children: options.map(({ value, label }, index) => (_jsx(SelectionItem, { id: id, value: value, label: label, type: "radio", className: clsx([styles.item, classes?.item]), control: _jsx(Radio, { classes: {
                            checked: clsx([styles.itemChecked, classes?.itemChecked]),
                            disabled: clsx([styles.itemDisabled, classes?.itemDisabled]),
                            root: clsx([styles.itemRoot, classes?.itemRoot]),
                        } }, void 0) }, `${id}-${index}`))) }, void 0)] }, void 0));
};
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map